import { Pencil } from "lucide-react";
import { Button } from "../../../ui/common/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "../../../ui/common/tooltip";
import { VERSION_DETAILS_COPY } from "../constants/versionDetails.constants";

interface VersionDetailsEditTriggerProps {
  versionLabel: string;
  disabled?: boolean;
  onClick: () => void;
}

/** Pencil on the version bar that opens the details editor. */
export const VersionDetailsEditTrigger = ({
  versionLabel,
  disabled = false,
  onClick
}: VersionDetailsEditTriggerProps) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <Button
        type="button"
        size="icon"
        variant="outline"
        className="tw-h-8 tw-w-8 tw-shrink-0"
        aria-label={VERSION_DETAILS_COPY.editAriaLabel(versionLabel)}
        disabled={disabled}
        onClick={onClick}
      >
        <Pencil className="tw-h-3.5 tw-w-3.5" />
      </Button>
    </TooltipTrigger>
    <TooltipContent>{VERSION_DETAILS_COPY.editTooltip}</TooltipContent>
  </Tooltip>
);
